import React from 'react';

import {
  QuickInsertActionInsert,
  QuickInsertItem,
} from '@atlaskit/editor-common/provider-factory';
import { NextEditorPlugin } from '@atlaskit/editor-common/types';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import { EditorState, Transaction } from '@atlaskit/editor-prosemirror/state';
import { SpotlightTarget } from '@atlaskit/onboarding';

import { CodeSuggestionsSpotlight } from './code-suggestions-spotlight';
import { CodeSuggestionsIcon } from './CodeSuggestionsIcon';
import { createFocusCodeSuggestionsPlugin } from './pm-plugins/focus-code-mirror';
import { registerEditorViewPlugin } from './pm-plugins/get-editor-view';
import { insertCodeSuggestionNode } from './utils';

const codeSuggestionsQuickInsertItem: QuickInsertItem = {
  title: 'Suggest Code',
  description: 'Make a code suggestion',
  priority: 100,
  keywords: ['suggestion'],
  // keyshortcut: '```suggestion', we might need this later
  icon: () => <CodeSuggestionsIcon />,
  action: (_insert: QuickInsertActionInsert, state: EditorState, _source) => {
    const { tr } = state;
    return insertCodeSuggestionNode(tr);
  },
};

export const codeSuggestionsPlugin: NextEditorPlugin<'codeSuggestions'> = ({
  api,
}) => {
  return {
    name: 'codeSuggestions',
    pmPlugins: () => [
      {
        name: 'codeSuggestionsRegisterEditorView',
        plugin: () => registerEditorViewPlugin(),
      },
      {
        name: 'codeSuggestionsFocusPlugin',
        plugin: () => createFocusCodeSuggestionsPlugin(),
      },
    ],
    primaryToolbarComponent: () => {
      return (
        <>
          <CodeSuggestionsSpotlight />
          <SpotlightTarget name="code-suggestions-icon">
            <ToolbarButton
              title="Suggest Code"
              onClick={() => {
                api?.core.actions.execute(({ tr }: { tr: Transaction }) => {
                  return insertCodeSuggestionNode(tr);
                });
              }}
              iconBefore={<CodeSuggestionsIcon />}
            />
          </SpotlightTarget>
        </>
      );
    },
    pluginsOptions: {
      quickInsert: () => [codeSuggestionsQuickInsertItem],
    },
  };
};
